/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

type PageHeaderFooterContextProps = {
  headerRef: React.RefObject<HTMLElement>;
  footerRef: React.RefObject<HTMLElement>;
};

const PageHeaderFooterContext = React.createContext<PageHeaderFooterContextProps>({
  headerRef: React.createRef<HTMLDivElement>(),
  footerRef: React.createRef<HTMLDivElement>(),
});

export function usePageHeaderFooterContext() {
  return React.useContext(PageHeaderFooterContext);
}

export const PageHeaderFooterProvider = ({
  children,
  ...value
}: React.PropsWithChildren<PageHeaderFooterContextProps>) => {
  return <PageHeaderFooterContext.Provider value={value}>{children}</PageHeaderFooterContext.Provider>;
};
